import { mapActions, mapGetters } from 'vuex'

const EntryTable = () => import('@/components/management/officer/EntryTable')

export default {
  components: {
    EntryTable
  },
  computed: {
    ...mapGetters('Officer', [
      'officers'
    ])
  },
  methods: {
    ...mapActions('Officer', [
      'getOfficers'
    ]),
    init () {
      this.getOfficers()
    }
  },
  created () {
    this.init()
  }
}
